export default "__VITE_ASSET__hCIBGU4s__"